export const updateDarkModeClasses = (darkModeSelected) => {
  document.querySelector('html').classList.remove('dark')
}
